const MuiOutlinedInput = {
  styleOverrides: {
    notchedOutline: {
      borderColor: '#ecebea',
    },
  },
};

export default MuiOutlinedInput;
